import { render, staticRenderFns } from "./AssetValueDisplay.vue?vue&type=template&id=e4b5c040&scoped=true&"
import script from "./AssetValueDisplay.vue?vue&type=script&lang=js&"
export * from "./AssetValueDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b5c040",
  null
  
)

export default component.exports